import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LangSwitcherComponent } from './lang-switcher.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule,
        TranslateModule
    ],
  declarations: [
    LangSwitcherComponent
  ],
  exports: [
    LangSwitcherComponent
  ]
})
export class LangSwitcherModule { }
